import React from 'react'
import PropTypes from 'prop-types'
import ShowContact from './ShowContact'
import UpdateContact from './UpdateContact'

const EnabledField = ({ editingContact, contactInfo, contactInfoLabel, handleChange, handleSave, editContact }) => (
  editingContact ?
    (
      <UpdateContact
        contactInfo={contactInfo}
        handleChange={handleChange}
        handleSave={handleSave}
      />
    ) : (
      <ShowContact
        contactInfoLabel={contactInfoLabel}
        contactInfo={contactInfo}
        editContact={editContact}
      />
    )
)

EnabledField.PropTypes = {
  editingContact: PropTypes.bool.isRequired,
  contactInfo: PropTypes.string.isRequired,
  contactInfoLabel: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  editContact: PropTypes.func.isRequired,
}

export default EnabledField



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/ContactField/EnabledField/index.js